// extracted by mini-css-extract-plugin
export default {"root":"HeaderSearchResult_root__dzXb5","list":"HeaderSearchResult_list__yft2+","item":"HeaderSearchResult_item__Gyw-J"};